import React from "react";

const Gracias = () => {
    return(
        <div id="gracias">
            <div className="content">
                <div className="titulo">
                    <img src="img/gracias.png" alt="gracias"></img>
                </div>
                <h2>Te contactaremos pronto.</h2>
                <div id="chica"><img src="img/chica-final.png" alt="chica"></img></div>
                <div id="logo-gracias"><img src="img/logo-scotia.jpg" alt="logo"></img></div> 
            </div>
        </div>
    );
}

export default Gracias;